var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 139,
    viewBox: "0 0 117 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_299_9940",
    maskUnits: "userSpaceOnUse",
    x: 0.896484,
    y: 0.132812,
    width: 116,
    height: 139,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.896484,
    y: 0.132812,
    width: 116,
    height: 139
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89648 58.1522C7.89648 30.0197 30.7833 7.13281 58.8965 7.13281C87.0291 7.13281 109.896 30.0197 109.896 58.1522C109.896 78.4745 97.9868 96.6597 79.4713 104.82L62.0633 129.824C61.3445 130.854 60.1593 131.476 58.9159 131.476H58.8965C57.6531 131.476 56.4679 130.854 55.7491 129.824L38.3216 104.82C19.8062 96.6597 7.89648 78.4745 7.89648 58.1522Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89648 58.1522C7.89648 30.0197 30.7833 7.13281 58.8965 7.13281C87.0291 7.13281 109.896 30.0197 109.896 58.1522C109.896 78.4745 97.9868 96.6597 79.4713 104.82L62.0633 129.824C61.3445 130.854 60.1593 131.476 58.9159 131.476H58.8965C57.6531 131.476 56.4679 130.854 55.7491 129.824L38.3216 104.82C19.8062 96.6597 7.89648 78.4745 7.89648 58.1522Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4713 104.82L76.6483 98.4141L74.8496 99.2069L73.7265 100.82L79.4713 104.82ZM62.0633 129.824L67.8031 133.831L67.8082 133.824L62.0633 129.824ZM55.7491 129.824L50.0063 133.827L50.0093 133.831L55.7491 129.824ZM38.3216 104.82L44.0644 100.817L42.9416 99.2061L41.1446 98.4141L38.3216 104.82ZM58.8965 0.132812C26.9156 0.132812 0.896484 26.1554 0.896484 58.1522H14.8965C14.8965 33.8839 34.6511 14.1328 58.8965 14.1328V0.132812ZM116.896 58.1522C116.896 26.1571 90.8985 0.132812 58.8965 0.132812V14.1328C83.1596 14.1328 102.896 33.8822 102.896 58.1522H116.896ZM82.2943 111.225C103.343 101.949 116.896 81.2542 116.896 58.1522H102.896C102.896 75.6949 92.6301 91.3708 76.6483 98.4141L82.2943 111.225ZM67.8082 133.824L85.2162 108.819L73.7265 100.82L56.3185 125.825L67.8082 133.824ZM58.9159 138.476C62.4731 138.476 65.7901 136.715 67.8031 133.831L56.3236 125.817C56.8989 124.993 57.8456 124.476 58.9159 124.476V138.476ZM58.8965 138.476H58.9159V124.476H58.8965V138.476ZM50.0093 133.831C52.0223 136.715 55.3393 138.476 58.8965 138.476V124.476C59.9668 124.476 60.9135 124.993 61.4888 125.817L50.0093 133.831ZM32.5788 108.822L50.0063 133.827L61.4918 125.822L44.0644 100.817L32.5788 108.822ZM0.896484 58.1522C0.896484 81.2542 14.4495 101.949 35.4986 111.225L41.1446 98.4141C25.1629 91.3708 14.8965 75.6949 14.8965 58.1522H0.896484Z",
    fill: "white",
    mask: "url(#path-1-outside-1_299_9940)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMarker);
export default __webpack_public_path__ + "static/media/orange-marker.1dfaab5c352ef126f7d6b5a19bd0c3bd.svg";
export { ForwardRef as ReactComponent };